/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useCountryContext } from "../../../../../context/country/countryContext/CountryContext";
import {
  Title,
  GoBack,
  Select,
  TextArea,
  MyMessage,
  InputField,
  MyActionButton,
  SelectInput,
  MyButton,
} from "../../../component/Component";
import {
  getAddLevel,
  getEditLevel,
} from "../../../../../middlewares/sysNavigation/SysNavigation";
import { validateFields } from "../../../../../controllers/levels/levelsControllers";
import { defaultImage } from "../../../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../../../../doseeData/utils/Utils";
import { useBaseLevelContext } from "../../../../../context/levels/BaseLevelContext";
import GenerateDescription from "../../../../doseeData/utils/GenerateDescription";

const levelsRoute = "/levels";

const Edit = () => {
  const { update } = useBaseLevelContext();
  const level = getEditLevel();
  const { countries, fetchCountries } = useCountryContext();

  const labelRaw = getAddLevel() ? getAddLevel() : "First";
  const label = String(labelRaw);
  const normalizedLabel = label.toLowerCase();

  const countryId = level?.country_id;

  const [isCity, setIsCity] = useState(level?.is_city);
  const [thumbnail, setThumbnail] = useState(level?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(level?.image_cdn_id);

  const [gdp, set_gdp] = useState(level?.gdp);
  const [levelName, set_levelName] = useState(level?.name);
  const [population, set_population] = useState(level?.population);
  const [description, set_description] = useState(level?.description);

  const [tourism, set_tourism] = useState(level?.tourism);
  const [safety_indicator, set_safety_indicator] = useState(level?.safety_indicator);

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  useEffect(() => {
    if (!countries) fetchCountries();
  }, [countries, fetchCountries]);

  const responses = (isError, msg) => {
    setError(isError);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const sendAddCountryRequest = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validation = validateFields(
      gdp,
      levelName,
      population,
      tourism,
      safety_indicator,
      description
    );

    if (validation.isError) {
      setLoading(false);
      return responses(validation.isError, validation.message);
    }
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, "Image Required");
    }
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const dataObject = {
      country_id: countryId,
      name: levelName,
      slug: levelName.toLowerCase().replace(/\s/g, "_"),
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "x",
      description: description,
      population: population,
      is_city: isCity,
      main_city: levelName,
      gdp: gdp,
      tourism: tourism,
      safety_indicator: safety_indicator,
      status: 1,
    };

    if (normalizedLabel === "first") {
      dataObject.first_level_label = levelName;
    } else if (normalizedLabel === "second") {
      dataObject.first_level_id = level?.first_level_id;
      dataObject.second_level_label = levelName;
    } else if (normalizedLabel === "third") {
      dataObject.first_level_id = level?.first_level_id;
      dataObject.second_level_id = level?.second_level_id;
      dataObject.third_level_label = levelName;
    } else if (normalizedLabel === "fourth") {
      dataObject.first_level_id = level?.first_level_id;
      dataObject.second_level_id = level?.second_level_id;
      dataObject.third_level_id = level?.third_level_id;
      dataObject.fourth_level_label = levelName;
    }

    const id =
      normalizedLabel === "first"
        ? level?.first_level_id
        : normalizedLabel === "second"
          ? level?.second_level_id
          : normalizedLabel === "third"
            ? level?.third_level_id
            : level?.fourth_level_id;

    setLoading(true);
    const { message: msg, status } = await update({
      level_id: id,
      data: dataObject,
      level: normalizedLabel,
    });
    setLoading(false);

    if (status === 200 || status === 201) {
      return responses(false, msg);
    } else {
      return responses(true, msg);
    }
  };

  const countryName =
    countries?.find((c) => c?.country_id === countryId)?.name || "Levels";

  return (
    <div className="overflow-y-auto p-3 lg:p-4 h-full rounded-b-xl bg-gray-50">
      <GoBack props={{ route: `${levelsRoute}/${normalizedLabel}` }} />

      {showDescriptionModal ? (
        <GenerateDescription
          setDescription={set_description}
          setShowDescriptionModal={setShowDescriptionModal}
        />
      ) : null}

      <form onSubmit={sendAddCountryRequest}>
        <div className="mx-auto max-w-7xl">
          <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <Title props={{ title: `Edit ${label} Level` }} />
                <p className="mt-1 text-[11px] text-gray-600">
                  Update hierarchy, details, media and safety information.
                </p>
              </div>
              <div className="flex gap-2">
                <span className="rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-[11px] font-semibold text-gray-700">
                  Level: {label}
                </span>
                <span className="rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-[11px] font-semibold text-gray-700">
                  Country: {countryName || "—"}
                </span>
              </div>
            </div>

            <div className="mt-3">
              <MyMessage
                error={error}
                message={message}
                success={success}
                onExpired={() => {
                  setError(false);
                  setSuccess(false);
                }}
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage("");
                }}
              />
            </div>
          </div>

          <div className="mt-4 grid grid-cols-1 gap-4">
            <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <p className="mb-3 text-xs font-semibold text-gray-900">Media</p>
              {countries && countryId ? (
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={image_kit_folder(countryName, FOLDERS.LEVELS)}
                />
              ) : (
                <div className="rounded-xl border border-dashed border-gray-200 bg-gray-50 p-6 text-center text-sm text-gray-700">
                  Country not found. Please ensure this level is linked to a country.
                </div>
              )}
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <p className="mb-3 text-xs font-semibold text-gray-900">Level Details</p>
              <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4">
                <InputField
                  props={{
                    id: "levelName",
                    title: `${label} Level Name`,
                    type: "text",
                    required: true,
                    value: levelName ? levelName : "",
                    onChange: (e) => {
                      set_levelName(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <SelectInput
                  defaultValue={isCity && isCity === 1 ? "yes" : "no"}
                  options={["no", "yes"]}
                  title={"Is it a City?"}
                  onChange={(e) => {
                    if (e.target.selectedIndex === 0) setIsCity(0);
                    else setIsCity(1);
                    setError(null);
                    setSuccess(null);
                  }}
                />
                <InputField
                  props={{
                    id: "population",
                    title: "Population",
                    type: "number",
                    required: true,
                    value: population ? population : "",
                    onChange: (e) => {
                      set_population(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "gdp",
                    title: "GDP",
                    type: "number",
                    required: true,
                    value: gdp ? gdp : "",
                    onChange: (e) => {
                      set_gdp(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <div className="mb-3 flex items-center justify-between">
                <p className="text-xs font-semibold text-gray-900">Description</p>
                <MyButton onClick={() => setShowDescriptionModal(true)} className="bg-blue-700 py-2 px-3 text-xs">
                  Generate Description
                </MyButton>
              </div>
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    set_description(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <p className="mb-3 text-xs font-semibold text-gray-900">Safety and Security</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <Select
                  props={{
                    id: "tourism",
                    title: "Tourism",
                    required: true,
                    option: ["safe", "intermediate", "danger"],
                    onChange: (e) => {
                      set_tourism(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <Select
                  props={{
                    id: "safety_indicator",
                    title: "Safety Indicator",
                    required: true,
                    option: ["safe", "intermediate", "danger"],
                    onChange: (e) => {
                      set_safety_indicator(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-5 flex justify-end">
            <MyActionButton
              loading={loading}
              title="Save Changes"
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Edit;
